import { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import QuickLinks from './components/QuickLinks';
import NewsSection from './components/NewsSection';
import DailyWisdom from './components/DailyWisdom';
import Footer from './components/Footer';

export default function HomePage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % 3);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 via-white to-amber-50">
      <Header />
      <HeroSection currentSlide={currentSlide} setCurrentSlide={setCurrentSlide} />
      <QuickLinks />
      <NewsSection />
      <DailyWisdom />
      <Footer />
    </div>
  );
}
